import type { QUnitType } from 'dayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import type { DashboardFilter } from '../../useDashboardStore';
import { convertDateRangeValues } from '../../widgets/filterHelpers';

dayjs.extend(utc);

/**
 * The dashboard date range as the pre-resolved UTC ISO instants a register
 * hook's `dateRange` argument takes (COI-600). Both bounds are INCLUSIVE,
 * matching `DashboardFilterArgs`.
 */
export const toIsoBounds = (
  dateRange: DashboardFilter['dateRange'],
  precision: QUnitType = 'day'
): { from?: string; to?: string } => {
  if (!dateRange) {
    return {};
  }

  const { startDate, endDate } = convertDateRangeValues(dateRange);
  if (!startDate || !endDate) {
    return {};
  }

  return {
    from: dayjs.utc(startDate).startOf(precision).toISOString(),
    to: dayjs.utc(endDate).endOf(precision).toISOString(),
  };
};
